import type { JSX } from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

type EditURLButtonProps = {
	onEditUrl: () => Promise<void> | void;
};

export function EditURLButton({ onEditUrl }: EditURLButtonProps): JSX.Element {
	return (
		<Button
			variant="tertiary"
			onClick={onEditUrl}
			data-testid="customUrl-edit-url-link"
			data-qa="customUrl-edit-url-link"
			size="small"
			className="py-0 text-typography-strong md:py-3"
		>
			<Text className="leading-5" fontWeight="bold">
				<Translate value="corgi.petition.starter_dashboard.grow_petition.copy_link.edit_link" />
			</Text>
		</Button>
	);
}
